// extracted by mini-css-extract-plugin
export default {"userManager":"UserManager_userManager__OpmMC"};